/** Convert h:mm a/p to H:mm
 * i.e. 12 hour time to 24 hour time
 * @param {string} time - h:mm a/p format
 * @returns {string} time in H:mm format
 */
export const to24HrTime = (time: string): string => {
  if (typeof time !== 'string') {
    return ''
  }
  const [hr, min, ap] = time.toLowerCase().match(/\d+|[a-z]+/g) || []
  const hour = parseInt(hr || '0')
  return `${`0${(hour % 12) + (ap === 'am' ? 0 : 12)}`.slice(-2)}:${min}`
}
